<script setup>

const props = defineProps({
  title: {type: String, default: "Confirmation modal"},
  isOpen: {type: Boolean, default: false},
  content: {type: String, default: "Are you sure you want to perform this action?"},
  cancel_text: {type: String, default: "Cancel"},
  confirm_text: {type: String, default: "Yes"},
})

const emit = defineEmits(['close', 'confirm', 'cancel'])
</script>
<template>
  <transition name="fade">
    <div v-if="props.isOpen"
         class="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-50 p-4"
         @click.self="emit('close')"
    >
      <div
        class="bg-white p-8 rounded-[4px] shadow-2xl max-w-[60%] w-full relative overflow-hidden">
        <!-- Header -->
        <div class="flex justify-between items-center mb-6">
          <h3 class="text-xl font-bold text-dark_blue">{{ props.title }}</h3>
          <button @click="emit('close')" class="text-slate-500 hover:text-red-400 transition-colors">
            <i class="fas fa-times text-xl"></i>
          </button>
        </div>

        <div>
          <p>{{content}}</p>
        </div>

        <div class="flex gap-2 justify-end mt-4">
          <button @click="emit('cancel')" class="py-3 px-5 rounded-[4px] bg-orange-450 text-white font-bold text-sm">
            {{props.cancel_text}}
          </button>
          <button @click="emit('confirm')" class="py-3 px-5 rounded-[4px] bg-blue-450 text-white font-bold text-sm">
            {{props.confirm_text}}
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>
